<template>
  <div class="container-fluid">
    <div class="center">
      <span class="xz-title">{{location.name}}</span><br/>
      <span>Org.nr. {{location.vatNumber}} MVA</span>
      <hr class="horizontal-dashed"/>
      <div class="xz-title mb-4">
          <h5> Alkoholrapport </h5>
      </div>
    </div>
    <span>Fra og med dato: {{ formatDate(fromDate) }}</span><br/>
    <span>Til og med dato: {{ formatDate(toDate) }}</span><br/>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
import moment from 'moment'
import MerchantUtil from "@/util/MerchantUtil";

export default {
  props: {
    location: Object,
    fromDate: String,
    toDate: String
  },
  methods: {
    useFunctionality(){
      return MerchantUtil.useFunctionality();
    },
    formatDate(date) {
      return (moment(date)).format('DD.MM.YYYY');
    }
  }
}
</script>